// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.9708 9.0385L3.10742 3.11353L9.0324 19.9769L12.4098 15.2485L18.1833 21.022L21.0117 18.1936L15.2376 12.4194L19.9708 9.0385Z"}}]};

const CursorFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'cursor-filled',
    ref,
    icon: element,
  },
));

CursorFilledIcon.displayName = 'CursorFilledIcon';

export default CursorFilledIcon;
